import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface ProductManagementHeaderProps {
  basePath: string;
}

const ProductManagementHeader: React.FC<ProductManagementHeaderProps> = ({ basePath }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{
      mb: 4,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexDirection: { xs: 'column', md: 'row' },
      gap: { xs: 2, md: 0 }
    }}>
      <Box>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' },
            fontWeight: 800,
            background: 'linear-gradient(135deg, #00d4ff 0%, #ff0080 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {t('admin.productManagement')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
        >
          {t('admin.manageCatalogDescription')}
        </Typography>
      </Box>
      <Box sx={{
        display: 'flex',
        gap: { xs: 1, sm: 2 },
        width: { xs: '100%', sm: 'auto' },
        flexWrap: 'wrap'
      }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => navigate(`${basePath}/new`)}
          size="small"
          sx={{
            flex: { xs: 1, sm: 'none' },
            fontSize: { xs: '0.875rem', sm: '1rem' },
            background: 'linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)',
            boxShadow: '0 2px 8px rgba(0,212,255,0.2)',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 3px 12px rgba(0,212,255,0.25)',
            },
          }}
        >
          {t('admin.addProduct')}
        </Button>
      </Box>
    </Box>
  );
};

export default ProductManagementHeader;